import React from 'react'
import MaterialSymbol from '../material-symbol'

const MoneyOff = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="money_off" {...props} />
))

MoneyOff.displayName = 'MoneyOff'

export default MoneyOff
